export * from './apollo';

export const CONFIG = {
  LOCALE: 'pl',
  PAY_U_PROVISION: Number(process.env.REACT_APP_E_BURSA_PAY_U_PROVISION),
  APP_TYPE: process.env.REACT_APP_E_BURSA_APP_TYPE,
  DORMITORY_WEB_PAGE: 'https://www.bursa-ts.szczecin.pl/',
};
